/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.

  var Sage = {
    // All pages
    common: {
      init: function () {
        $(".hamburger.menu-toggle").click(function () {
          $(this).toggleClass("is-active");
          $("nav.aside .button-gold").fadeToggle();
          $(".nav-primary").fadeToggle();
          $("body").toggleClass("overflow");
        });

        $("select").select2();

        $("#print").click(function () {
          window.print();
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    // Home page
    home: {
      init: function () {
        var videoSlider = $(".carousel").bxSlider({
          loop: true,
          controls: false,
          pager: true,
          video: true,
          auto: false,
          speed: 3000,
          pause: 2500,
        });

        $(".scroll-to img").click(function () {
          $("html, body").animate(
            {
              scrollTop: $("#scrollPoint").offset().top - 50,
            },
            1000
          );
        });

        $(".filter-wrap .inner").click(function () {
          $(".filter-wrap .inner .hamburger").toggleClass("is-active");
          $("ul.filters").slideToggle();
        });

        $("ul.filters li a").click(function (e) {
          e.preventDefault();

          $("ul.filters li a").each(function () {
            $(this).removeClass("active");
          });
          $(this).addClass("active");

          var section = $(this).data("filter");

          $.ajax({
            method: "POST",
            url: ajaxUrl,
            dataType: "json",
            data: {
              action: "get_actors_ajax",
              section: section,
              filter: "all",
              homepage: true,
              postPerPage: 4,
            },
            success: function (response) {
              $(".latest .slider").empty();

              var html = "";

              if (response.data.actor.length > 0) {
                html = '<div class="slide">';
                html += '<div class="row">';
                for (var i = 0; i < response.data.actor.length; i++) {
                  html += '<div class="col-sm-12 col-md-6 col-lg-3">';
                  html += '<div class="flip-card">';

                  html +=
                    '<figure class="front" style="background:url(' +
                    response.data.actor[i].headshot +
                    ');"></figure>';

                  html += '<figure class="back">';
                  html +=
                    '<strong class="card-text">' +
                    response.data.actor[i].name +
                    "</strong>";
                  html += "<p>" + response.data.actor[i].about + "</p>";
                  html += "</figure>";
                  html += "</div>";
                  html += "</div>";
                }
                html += "</div>";
                html += "</div>";
                $(".latest .slider").append(html);
              } else {
                $(".latest .slider").append(
                  "<h4>There is currently no actors in this section</h4>"
                );
              }
            },
          });
        });
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },

    news: {
      init: function () {
        $("#moreNews").click(function () {
          var total = $(this).data("total");
          var current = $(".news-artilces article").length;
          var featured = $(this).data("featured");

          $.ajax({
            method: "POST",
            url: ajaxUrl,
            dataType: "json",
            data: {
              action: "get_more_news",
              total: total,
              current: current,
              featured: featured,
            },

            beforeSend: function () {
              $(".news-artilces").append(
                '<div class="loading"><i class="fa fa-circle-o-notch fa-spin"></i></div>'
              );
            },

            success: function (response) {
              var html = "";
              html += '<div class="row">';
              for (var i = 0; i < response.data.news.length; i++) {
                html += '<div class="col-sm-12 col-md-6 col-lg-4">';
                html += "<article>";
                html +=
                  '<div class="news-img" style="background:url(' +
                  response.data.news[i].image +
                  ')"></div>';
                html += "<h5>" + response.data.news[i].title + "</h5>";
                html +=
                  '<a class="more" href="' +
                  response.data.news[i].permalink +
                  '">read more</a>';
                html += "</article>";
                html += "</div>";
              }
              html += "</div>";
              $(".news-artilces").append(html);
              $(".news-artilces .loading").hide();
              current = $(".news-artilces article").length;
              if (current === total) {
                $("#moreNews").hide();
              }
            },
          });
        });
      },
    },

    single_actor: {
      init: function () {
        var headShot = $(".head-shot-carousel").bxSlider({
          slideMargin: 20,
          moveSlides: 1,
          pager: false,
          nextText: "",
          prevText: "",
          preventDefaultSwipeX: false,
          nextSelector: "#next",
          prevSelector: "#prev",
          controls: true,
          useCSS: false,
          auto: false,
        });

        $(".pager a").click(function (e) {
          e.preventDefault();
          var slide = $(this).data("slide");
          headShot.goToSlide(slide);
        });

        $("#next").click(function () {
          headShot.goToPrevSlide();
          return false;
        });

        $("#prev").click(function () {
          headShot.goToNextSlide();
          return false;
        });
      },
    },
    single_voiceover: {
      init: function () {
        var headShot = $(".head-shot-carousel").bxSlider({
          slideMargin: 20,
          moveSlides: 1,
          pager: false,
          nextText: "",
          prevText: "",
          preventDefaultSwipeX: false,
          nextSelector: "#next",
          prevSelector: "#prev",
          controls: true,
          useCSS: false,
          auto: false,
        });

        $(".pager a").click(function (e) {
          e.preventDefault();
          var slide = $(this).data("slide");
          headShot.goToSlide(slide);
        });

        $("#next").click(function () {
          headShot.goToPrevSlide();
          return false;
        });

        $("#prev").click(function () {
          headShot.goToNextSlide();
          return false;
        });
      },
    },

    voiceovers: {
      init: function () {
        $("#search").keyup(function () {
          var filter = $("#search").val().toLowerCase();
          $("strong.card-text").each(function () {
            if ($(this).text().toLowerCase().indexOf(filter) > -1) {
              $(this).closest("#talent").show();
            } else {
              $(this).closest("#talent").hide();
            }
          });
        });

        $(".filter-wrap .inner").click(function () {
          $(".filter-wrap .inner .hamburger").toggleClass("is-active");
          $("ul.filters").slideToggle();
          $("ul.filters-secondary").slideToggle();
        });

        $("ul.filters li a, ul.filters-secondary li a").click(function (e) {
          e.preventDefault();

          // Check which filter was clicked
          if ($(this).closest("ul").hasClass("filters-secondary")) {
            // Change active classes for filters
            $("ul.filters-secondary li a").each(function () {
              $(this).removeClass("active");
            });
          } else {
            $("ul.filters li a").each(function () {
              $(this).removeClass("active");
            });
          }
          $(this).addClass("active");

          // Grab gender filter - always active
          const filter = document.querySelector(".gender-filter.active").dataset
            .filter;

          // Grab the secondary filter
          const subFilterEle = document.querySelector(
            ".secondary-filter.active"
          );
          // Perform secondary filter check if unselected
          const subFilter = subFilterEle
            ? subFilterEle.dataset.subfilter
            : null;

          // Depending on the array length navigate to the parent filter - usually 'adult' or 'child'
          var arr = window.location.pathname.split("/");
          var section = arr[2];

          var sort = $("#sort").val();

          if (!subFilter) {
            window.history.replaceState(
              "page",
              "Actors",
              "/voiceovers/" + section + "/" + filter
            );
          } else {
            window.history.replaceState(
              "page",
              "Actors",
              "/voiceovers/" + section + "/" + filter + "/" + subFilter
            );
          }

          $.ajax({
            method: "POST",
            url: ajaxUrl,
            dataType: "json",
            data: {
              action: "get_voiceovers_ajax",
              section: section,
              filter: filter,
              subFilter: subFilter,
            },
            beforeSend: function () {
              $("#actor-list").append(
                '<div class="loading"><i class="fa fa-circle-o-notch fa-spin"></i></div>'
              );
            },
            success: function (response) {
              if (response.success) {
                var html = '<div class="row">';
                for (var i = 0; i < response.data.actor.length; i++) {
                  html +=
                    '<div id="talent" class="col-sm-12 col-md-6 col-lg-4">';
                  html += '<div class="border-around">';
                  html += '<div class="card">';
                  html += '<div class="card-block">';
                  html +=
                    '<strong class="card-text">' +
                    response.data.actor[i].name +
                    "</strong>";
                  html += "</div>";
                  html += "</div>";
                  if (response.data.actor[i].content !== "") {
                    html +=
                      '<div class="border">' +
                      response.data.actor[i].content +
                      "</div>";
                  }
                  if (response.data.actor[i].playing_age !== "") {
                    html +=
                      '<div class="border"><strong>Playing age: </strong>' +
                      response.data.actor[i].playing_age +
                      "</div>";
                  }
                  if (response.data.actor[i].accents !== "") {
                    html +=
                      '<div class="border"><strong>Accents: </strong>' +
                      response.data.actor[i].accents +
                      "</div>";
                  }
                  if (response.data.actor[i].languages !== "") {
                    html +=
                      '<div class="border"><strong>Languages: </strong>' +
                      response.data.actor[i].languages +
                      "</div>";
                  }
                  if (response.data.actor[i].characteristics !== "") {
                    html +=
                      '<div class="border"><strong>Characteristics: </strong><br>' +
                      response.data.actor[i].characteristics +
                      "</div>";
                  }
                  if (response.data.actor[i].voice_clip_url !== undefined) {
                    for (
                      var n = 0;
                      n < response.data.actor[i].voice_clip_url.length;
                      n++
                    ) {
                      if (response.data.actor[i].voice_clip_title[n] !== "") {
                        html +=
                          '<strong class="d-block">' +
                          response.data.actor[i].voice_clip_title[n] +
                          "</strong>";
                      }
                      if (response.data.actor[i].voice_clip_url[n] !== "") {
                        html +=
                          "<audio controls><source src=" +
                          response.data.actor[i].voice_clip_url[n] +
                          ' type="audio/mpeg"></audio>';
                      }
                    }
                  }
                  html += "</div>";
                  html += "</div>";
                }
                html += "</div>";
              }

              $("#actor-list").empty();
              $("#actor-list").append(html);
              $("nav.pagination").show();
              $("nav.pagination .prev").css({ visibility: "hidden" });
              if (response.data.total <= 1) {
                $("nav.pagination").hide();
              }
              $("nav.pagination .page-no").text(response.data.nextpage);
              $("nav.pagination .total-pages").text(response.data.total);
              $("nav.pagination .getPage").data(
                "total-pages",
                response.data.total
              );
            },
          });
        });
      },
    },

    // About us page, note the change from about-us to about_us.

    talent: {
      init: function () {
        $("#search").keyup(function () {
          var filter = $("#search").val().toLowerCase();
          $("strong.card-text").each(function () {
            if ($(this).text().toLowerCase().indexOf(filter) > -1) {
              $(this).closest("#talent").show();
            } else {
              $(this).closest("#talent").hide();
            }
          });
        });

        $(".filter-wrap .inner").click(function () {
          $(".filter-wrap .inner .hamburger").toggleClass("is-active");
          $("ul.filters").slideToggle();
          $("ul.filters-secondary").slideToggle();
        });

        $("ul.filters li a, ul.filters-secondary li a").click(function (e) {
          e.preventDefault();

          // Check which filter was clicked
          if ($(this).closest("ul").hasClass("filters-secondary")) {
            // Change active classes for filters
            $("ul.filters-secondary li a").each(function () {
              $(this).removeClass("active");
            });
          } else {
            $("ul.filters li a").each(function () {
              $(this).removeClass("active");
            });
          }
          $(this).addClass("active");

          // Grab gender filter - always active
          const filter = document.querySelector(".gender-filter.active").dataset
            .filter;

          // Grab the secondary filter
          const subFilterEle = document.querySelector(
            ".secondary-filter.active"
          );
          // Perform secondary filter check if unselected
          const subFilter = subFilterEle
            ? subFilterEle.dataset.subfilter
            : null;

          // Depending on the array length navigate to the parent filter - usually 'adult' or 'child'
          var arr = window.location.pathname.split("/");
          var section = arr[2];

          var sort = $("#sort").val();

          if (!subFilter) {
            window.history.replaceState(
              "page",
              "Actors",
              "/talent/" + section + "/" + filter
            );
          } else {
            window.history.replaceState(
              "page",
              "Actors",
              "/talent/" + section + "/" + filter + "/" + subFilter
            );
          }

          $.ajax({
            method: "POST",
            url: ajaxUrl,
            dataType: "json",
            data: {
              action: "get_actors_ajax",
              section: section,
              filter: filter,
              subFilter: subFilter,
            },
            beforeSend: function () {
              $("#actor-list").append(
                '<div class="loading"><i class="fa fa-circle-o-notch fa-spin"></i></div>'
              );
            },
            success: function (response) {
              if (response.success) {
                var html = '<div class="row">';
                for (var i = 0; i < response.data.actor.length; i++) {
                  html +=
                    '<div id="talent" class="col-sm-12 col-md-6 col-lg-2">';
                  html += '<div class="card">';
                  html += '<a href="' + response.data.actor[i].permalink + '">';
                  html +=
                    '<div class="card-img-top" style="background:url(' +
                    response.data.actor[i].headshot +
                    ');"></div>';
                  html += "</a>";
                  html += '<div class="card-block">';
                  html +=
                    '<strong class="card-text">' +
                    response.data.actor[i].name +
                    "</strong>";
                  html += "</div>";
                  html += "</div>";

                  html += "</div>";
                }
                html += "</div>";
              }

              $("#actor-list").empty();
              $("#actor-list").append(html);
            },
          });
        });

        // $("#sort").change(function (e) {
        //   e.preventDefault();

        //   var filter = $("ul.filters li a.active").data("filter");
        //   var subFilter = $("ul.filters li a.active").data("filter");
        //   var currentPage = $(this).data("current-page");
        //   var totalPages = $(this).data("total-pages");
        //   var postPerPage = $(this).data("post-per-page");
        //   var direction = $(this).data("direction");
        //   var sort = $(this).val();

        //   var arr = window.location.pathname.split("/");
        //   var section = arr[arr.length - 2];

        //   if (
        //     section === "all" ||
        //     section === "male" ||
        //     section === "female" ||
        //     section === "northern" ||
        //     section === "welsh"
        //   ) {
        //     section = arr[arr.length - 3];
        //   }

        //   $.ajax({
        //     method: "POST",
        //     url: ajaxUrl,
        //     dataType: "json",
        //     data: {
        //       action: "get_actors_ajax",
        //       section: section,
        //       filter: filter,
        //       subFilter: subFilter,
        //       sort: sort,
        //     },
        //     beforeSend: function () {
        //       $("#actor-list").append(
        //         '<div class="loading"><i class="fa fa-circle-o-notch fa-spin"></i></div>'
        //       );
        //     },
        //     success: function (response) {
        //       if (response.success) {
        //         var html = '<div class="row">';
        //         for (var i = 0; i < response.data.actor.length; i++) {
        //           html +=
        //             '<div id="talent" class="col-sm-12 col-md-6 col-lg-3">';
        //           html += '<div class="card">';
        //           html += '<a href="' + response.data.actor[i].permalink + '">';
        //           html +=
        //             '<div class="card-img-top" style="background:url(' +
        //             response.data.actor[i].headshot +
        //             ');"></div>';
        //           html += "</a>";
        //           html += '<div class="card-block">';
        //           html +=
        //             '<strong class="card-text">' +
        //             response.data.actor[i].name +
        //             "</strong>";
        //           html += "</div>";
        //           html += "</div>";

        //           html += "</div>";
        //         }
        //         html += "</div>";
        //       }

        //       $("#actor-list").empty();
        //       $("#actor-list").append(html);
        //       $("nav.pagination").show();
        //       $("nav.pagination .prev").css({ visibility: "hidden" });
        //       if (response.data.total <= 1) {
        //         $("nav.pagination").hide();
        //       }
        //       $("nav.pagination .page-no").text(response.data.nextpage);
        //       $("nav.pagination .total-pages").text(response.data.total);
        //       $("nav.pagination .getPage").data(
        //         "total-pages",
        //         response.data.total
        //       );
        //     },
        //   });
        // });

        $(".getPage").click(function (e) {
          e.preventDefault();

          var filter = $("ul.filters li a.active").data("filter");
          var subFilter = $("ul.filters-secondary li a.active").data("filter");
          var currentPage = $(this).data("current-page");
          var totalPages = $(this).data("total-pages");
          var postPerPage = $(this).data("post-per-page");
          var direction = $(this).data("direction");
          var sort = $("#sort").val();
          var arr = window.location.pathname.split("/");
          var section = arr[arr.length - 2];

          if (
            section === "all" ||
            section === "male" ||
            section === "female" ||
            section === "non-binary"
          ) {
            section = arr[arr.length - 3];
          }

          // $.ajax({
          //   method: "POST",
          //   url: ajaxUrl,
          //   dataType: "json",
          //   data: {
          //     action: "get_actors_ajax",
          //     currentPage: currentPage,
          //     totalPages: totalPages,
          //     postPerPage: postPerPage,
          //     direction: direction,
          //     section: section,
          //     filter: filter,
          //     subFilter: subFilter,
          //     sort: sort,
          //   },
          //   success: function (response) {
          //     var html = '<div class="row">';
          //     for (var i = 0; i < response.data.actor.length; i++) {
          //       html += '<div id="talent" class="col-sm-12 col-md-6 col-lg-3">';
          //       html += '<div class="card">';
          //       html += '<a href="' + response.data.actor[i].permalink + '">';
          //       html +=
          //         '<div class="card-img-top" style="background:url(' +
          //         response.data.actor[i].headshot +
          //         ');"></div>';
          //       html += "</a>";
          //       html += '<div class="card-block">';
          //       html +=
          //         '<strong class="card-text">' +
          //         response.data.actor[i].name +
          //         "</strong>";
          //       html += "</div>";
          //       html += "</div>";
          //       html += "</div>";
          //     }
          //     html += "</div>";

          //     $("#actor-list").empty();
          //     $("#actor-list").append(html);
          //     $("nav.pagination .page-no").text(response.data.nextpage);
          //     $("nav.pagination .getPage").data(
          //       "current-page",
          //       response.data.nextpage
          //     );
          //     $("nav.pagination .total-pages").text(response.data.total);
          //     $("nav.pagination .getPage").data(
          //       "total-pages",
          //       response.data.total
          //     );
          //     $("nav.pagination .next").css({ visibility: "visible" });
          //     $("nav.pagination .prev").css({ visibility: "visible" });
          //     if (response.data.nextpage === response.data.total) {
          //       $("nav.pagination .next").css({ visibility: "hidden" });
          //     }
          //     if (reponse.data.nextpage === 1) {
          //       $("nav.paginationn .prev").css({ visibility: "hidden" });
          //     }
          //   },
          // });
        });
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
